import { useState } from "react";
import { Fade } from "./Reveal";
import { LeadNum, Tags } from "./Bits";
import { CAREER, CAREER_EXTRA, CareerEntry } from "../data";

function CareerItem({ c }: { c: CareerEntry }) {
  return (
    <div className="career-item">
      <Fade className="career-date">{c.date.replace(/→/g, "→︎")}</Fade>
      <div>
        <Fade className="career-role">{c.role}</Fade>
        <Fade className="career-org">{c.org}</Fade>
        {c.tech && <Tags items={c.tech} style={{ margin: "10px 0 18px" }} />}
        {c.b.map((x) => (
          <Fade className="career-b" key={x}>
            {x}
          </Fade>
        ))}
      </div>
    </div>
  );
}

export function Career() {
  const [open, setOpen] = useState(false);

  return (
    <section id="career" style={{ background: "var(--paper-2)" }}>
      <LeadNum no="03" label="Career History" right="where I've shipped" />
      <div>
        {CAREER.map((c) => (
          <CareerItem c={c} key={c.role + c.org} />
        ))}
      </div>
      <button className="more-btn" onClick={() => setOpen((o) => !o)}>
        {open ? "Show less ×" : "Show full history +"}
      </button>
      <div className={`extra${open ? " open" : ""}`} style={{ marginTop: 10 }}>
        {CAREER_EXTRA.map((c) => (
          <CareerItem c={c} key={c.role + c.org} />
        ))}
      </div>
    </section>
  );
}
